import React, { useCallback, useEffect, useMemo } from 'react'
import { MasonryGrid } from '@egjs/react-grid'
import className from 'classnames/bind'

import style from './MyhouseMainMasonryGridLayout.module.scss'

import useMain from '@Hooks/myhouse/main/useMain'
import useDebounce from '@Hooks/common/useDebounce'

const cx = className.bind(style)

type Props = {
  children: React.ReactNode
  show?: boolean
}

const MyhouseMainMasonryGridLayout = React.forwardRef(({ children, show }: Props, ref: any) => {
  const { reduxMain, setRelocationGrid } = useMain()
  const { relocationGrid } = reduxMain
  const { landDebounce } = useDebounce()
  const DEBOUNCE_WAIT = 100

  const relocation = useCallback(() => {
    ref?.current?.updateItems()
    ref?.current?.renderItems()
    setRelocationGrid(false)
  }, [])

  const debouncedRelocation = useMemo(() => landDebounce(relocation, DEBOUNCE_WAIT), [relocation])

  // render 후 재처리
  useEffect(() => {
    debouncedRelocation()
  })

  //useEffect
  useEffect(() => {
    window.addEventListener('resize', debouncedRelocation)

    return () => {
      window.removeEventListener('resize', debouncedRelocation)
    }
  }, [])

  useEffect(() => {
    if (relocationGrid) {
      debouncedRelocation()
    }
  }, [relocationGrid])

  if (!(show ?? true)) {
    return null
  }

  return (
    <MasonryGrid ref={ref} className={cx('wrap_content')}>
      {children}
    </MasonryGrid>
  )
})
MyhouseMainMasonryGridLayout.displayName = 'MyhouseMainMasonryGridLayout'

export default MyhouseMainMasonryGridLayout
